module.exports = __webpack_public_path__ + "img/truck.f9ee6db1.png";